/**
 * ANCHOR GLASSES STRAPS - SHOPIFY THEME JS
 * Version: 3.0.0 - Complete rebuild from localhost
 * Uses Shopify AJAX Cart API for all cart operations
 */
(function() {
  'use strict';

  // ===== SHOPIFY CART STATE =====
  var cartState = { items: [], item_count: 0, total_price: 0 };

  // ===== DOM ELEMENTS =====
  var navbar = document.getElementById('navbar');
  var hamburger = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobileMenu');
  var mobileOverlay = document.getElementById('mobileOverlay');
  var cartBtn = document.getElementById('cartBtn');
  var cartDrawer = document.getElementById('cartDrawer');
  var cartOverlay = document.getElementById('cartOverlay');
  var cartClose = document.getElementById('cartClose');
  var cartItemsEl = document.getElementById('cartItems');
  var cartFooter = document.getElementById('cartFooter');
  var cartCount = document.getElementById('cartCount');
  var cartItemCount = document.getElementById('cartItemCount');
  var cartTotal = document.getElementById('cartTotal');
  var backToTop = document.getElementById('backToTop');
  var newsletterForm = document.getElementById('newsletterForm');

  // ===== HERO PARTICLES =====
  (function createParticles() {
    var container = document.getElementById('heroParticles');
    if (!container) return;
    for (var i = 0; i < 30; i++) {
      var dot = document.createElement('div');
      dot.className = 'dot';
      var size = Math.random() * 4 + 2;
      dot.style.width = size + 'px';
      dot.style.height = size + 'px';
      dot.style.left = Math.random() * 100 + '%';
      dot.style.top = Math.random() * 100 + '%';
      dot.style.animationDuration = (Math.random() * 10 + 8) + 's';
      dot.style.animationDelay = (Math.random() * 10) + 's';
      container.appendChild(dot);
    }
  })();

  // ===== NAVBAR SCROLL =====
  var announcementBar = document.querySelector('.announcement-bar');
  var announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
  window.addEventListener('scroll', function() {
    if (navbar) {
      if (window.scrollY > announcementHeight) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
    }
    if (backToTop) {
      if (window.scrollY > 600) {
        backToTop.classList.add('visible');
      } else {
        backToTop.classList.remove('visible');
      }
    }
  });

  // ===== MOBILE MENU =====
  if (hamburger && mobileMenu && mobileOverlay) {
    hamburger.addEventListener('click', function() {
      hamburger.classList.toggle('active');
      hamburger.setAttribute('aria-expanded', hamburger.classList.contains('active'));
      mobileMenu.classList.toggle('open');
      mobileOverlay.classList.toggle('open');
      document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
    });
    mobileOverlay.addEventListener('click', closeMobile);
    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', closeMobile);
    });
  }
  function closeMobile() {
    if (hamburger) hamburger.classList.remove('active');
    if (mobileMenu) mobileMenu.classList.remove('open');
    if (mobileOverlay) mobileOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ===== CART DRAWER =====
  if (cartBtn) cartBtn.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ===== SHOPIFY AJAX CART API =====
  // Expose globally so product templates can call it
  window._anchorFetchCart = function() { return fetchCart().then(function() { openCart(); bumpCartCount(); }); };
  window._anchorAddToCart = function(variantId, qty) { return addToCart(variantId, qty || 1); };

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartState = cart;
        renderCart(cart);
        return cart;
      });
  }

  function addToCart(variantId, qty) {
    variantId = parseInt(variantId);
    qty = parseInt(qty) || 1;
    if (!variantId || isNaN(variantId)) {
      return Promise.reject('Invalid variant ID');
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Add to cart failed: ' + r.status);
      return r.json();
    })
    .then(function(data) {
      // TikTok Pixel - AddToCart event
      if (window.ttq) {
        ttq.track('AddToCart', {
          content_id: variantId.toString(),
          content_type: 'product',
          quantity: qty,
          value: data.final_price ? data.final_price / 100 : 0,
          currency: 'USD'
        });
      }
      // Meta Pixel - AddToCart event
      if (window.fbq) {
        fbq('track', 'AddToCart', {
          content_ids: [variantId.toString()],
          content_type: 'product',
          value: data.final_price ? data.final_price / 100 : 0,
          currency: 'USD'
        });
      }
      return fetchCart();
    })
    .then(function() {
      openCart();
      bumpCartCount();
    });
  }

  function changeCartItem(lineKey, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      return fetchCart();
    });
  }

  function bumpCartCount() {
    if (cartCount) {
      cartCount.classList.remove('bump');
      void cartCount.offsetWidth;
      cartCount.classList.add('bump');
    }
  }

  function renderCart(cart) {
    var totalItems = cart.item_count;
    if (cartCount) cartCount.textContent = totalItems;
    if (cartItemCount) cartItemCount.textContent = totalItems;
    if (cartTotal) cartTotal.textContent = Shopify.formatMoney ? Shopify.formatMoney(cart.total_price) : '$' + (cart.total_price / 100).toFixed(2);

    // Free shipping threshold (in cents) — $14
    var FREE_SHIP_THRESHOLD = 1400;
    var shippingMsg = document.getElementById('cartShippingMsg');
    var freeShipEl = document.getElementById('cartFreeShip');

    if (cart.items.length === 0) {
      if (cartItemsEl) cartItemsEl.innerHTML = '<div class="cart-empty"><div class="cart-empty-icon">&#128722;</div><p>Your cart is empty</p><p style="font-size:0.82rem;margin-top:8px;">Add some adventure gear!</p></div>';
      if (cartFooter) cartFooter.style.display = 'none';
      var upsellEl = document.getElementById('cartUpsell');
      if (upsellEl) upsellEl.style.display = 'none';
      if (freeShipEl) freeShipEl.style.display = 'none';
    } else {
      if (cartFooter) cartFooter.style.display = 'block';

      // Shipping message
      if (shippingMsg) {
        if (cart.total_price >= FREE_SHIP_THRESHOLD) {
          shippingMsg.innerHTML = '&#10003; FREE shipping applied';
          shippingMsg.style.color = 'var(--success)';
        } else {
          var remaining = ((FREE_SHIP_THRESHOLD - cart.total_price) / 100).toFixed(2);
          shippingMsg.innerHTML = 'Add $' + remaining + ' more for free shipping';
          shippingMsg.style.color = '';
        }
      }

      // Exclude upsell items from discount counting
      var excludeHandles = ['anchor-microfiber-glasses-cleaning-cloths'];

      var uniqueProductIds = {};
      cart.items.forEach(function(item) {
        if (excludeHandles.indexOf(item.handle) === -1) {
          uniqueProductIds[item.product_id] = true;
        }
      });
      var uniqueProducts = Object.keys(uniqueProductIds).length;
      console.log("[Cart] Unique products:", uniqueProducts, "Items:", cart.items.length);
      var discountPct = 0;
      if (uniqueProducts >= 4) discountPct = 20;
      else if (uniqueProducts >= 3) discountPct = 15;
      else if (uniqueProducts >= 2) discountPct = 10;

      // Render items
      var html = '';
      var totalDiscount = 0;
      cart.items.forEach(function(item) {
        var imgSrc = item.image ? Shopify.Image ? Shopify.Image.getSizedImageUrl(item.image, 'small') : item.image : '';
        var unitPrice = item.final_line_price / 100 / item.quantity;
        var isCleaningCloth = item.handle === 'anchor-microfiber-glasses-cleaning-cloths';
        var isUpsellItem = excludeHandles.indexOf(item.handle) !== -1;
        var priceHtml = '';
        if (isCleaningCloth) {
          // Show 50% off for cleaning cloth — use actual Shopify price to avoid double discount
          var clothSale = 4.99;
          if (unitPrice > clothSale) {
            totalDiscount += (unitPrice - clothSale) * item.quantity;
            priceHtml = '<span style="text-decoration:line-through;color:rgba(240,244,248,0.35);font-size:0.78rem;margin-right:6px;">$' + unitPrice.toFixed(2) + '</span>' +
              '<span style="color:#22c55e;font-weight:700;">$' + clothSale.toFixed(2) + '</span>' +
              '<span style="background:#22c55e;color:#fff;font-size:0.65rem;font-weight:700;padding:2px 6px;border-radius:4px;margin-left:6px;">50% OFF</span>';
          } else {
            priceHtml = '<span style="color:#22c55e;font-weight:700;">$' + unitPrice.toFixed(2) + '</span>';
          }
        } else if (discountPct > 0 && !isUpsellItem) {
          var discountedPrice = unitPrice * (1 - discountPct / 100);
          totalDiscount += (unitPrice - discountedPrice) * item.quantity;
          priceHtml = '<span style="text-decoration:line-through;color:rgba(240,244,248,0.35);font-size:0.78rem;margin-right:6px;">$' + unitPrice.toFixed(2) + '</span>' +
            '<span style="color:#22c55e;font-weight:700;">$' + discountedPrice.toFixed(2) + '</span>' +
            '<span style="background:rgba(34,197,94,0.15);color:#22c55e;font-size:0.65rem;font-weight:700;padding:2px 6px;border-radius:4px;margin-left:6px;">' + discountPct + '% OFF</span>';
        } else {
          priceHtml = '$' + unitPrice.toFixed(2);
        }
        html += '<div class="cart-item">' +
          '<div class="cart-item-img">' + (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.title + '">' : '') + '</div>' +
          '<div class="cart-item-details">' +
            '<div class="cart-item-name">' + item.product_title + '</div>' +
            (item.variant_title ? '<div style="font-size:0.75rem;color:rgba(240,244,248,0.45);margin-bottom:2px;">' + item.variant_title + '</div>' : '') +
            '<div class="cart-item-price">' + priceHtml + '</div>' +
            '<div class="cart-item-qty">' +
              '<button onclick="window._cartQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">-</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button onclick="window._cartQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>' +
            '</div>' +
          '</div>' +
          '<button class="cart-item-remove" onclick="window._cartQty(\'' + item.key + '\',0)">&#10005;</button>' +
        '</div>';
      });
      // Add upsell prompt for single-item carts
      if (uniqueProducts === 1) {
        html += '<div style="background:linear-gradient(135deg,rgba(14,165,233,0.1),rgba(255,107,53,0.05));border:1px solid rgba(14,165,233,0.2);border-radius:10px;padding:12px;margin:12px 0;text-align:center;">' +
          '<div style="font-size:0.82rem;font-weight:600;color:var(--accent2);">Add 1 more item and save 10% on your order!</div>' +
          '<a href="/collections/all" style="display:inline-block;margin-top:6px;font-size:0.75rem;color:var(--accent1);font-weight:600;text-decoration:none;">Shop More Products &rarr;</a>' +
        '</div>';
      }
      if (cartItemsEl) cartItemsEl.innerHTML = html;

      // Show/hide bundle discount in footer
      var origRow = document.getElementById('cartOriginalRow');
      var discRow = document.getElementById('cartDiscountRow');
      if (totalDiscount > 0 && origRow && discRow) {
        // Calculate true subtotal by summing all item prices at full price
        var trueSubtotal = 0;
        cart.items.forEach(function(item) { trueSubtotal += item.final_line_price; });
        origRow.style.display = 'flex';
        discRow.style.display = 'flex';
        document.getElementById('cartOriginal').textContent = '$' + (trueSubtotal / 100).toFixed(2);
        document.getElementById('cartDiscountLabel').textContent = discountPct + '% Off';
        document.getElementById('cartDiscountAmt').textContent = '-$' + totalDiscount.toFixed(2);
        var discountedTotal = (trueSubtotal / 100) - totalDiscount;
        if (cartTotal) cartTotal.textContent = '$' + discountedTotal.toFixed(2);
      } else {
        if (origRow) origRow.style.display = 'none';
        if (discRow) discRow.style.display = 'none';
      }

      // Upsell logic - show if cart has items and upsell product handle is set
      renderUpsell(cart);
    }
  }

  // ===== UPSELL =====
  var upsellAdded = false;
  var upsellRules = [];
  var activeUpsell = null;

  try {
    var rulesEl = document.getElementById('upsellRules');
    if (rulesEl) upsellRules = JSON.parse(rulesEl.textContent);
  } catch(e) {}

  function renderUpsell(cart) {
    var upsellEl = document.getElementById('cartUpsell');
    if (!upsellEl) return;
    if (cart.items.length === 0) { upsellEl.style.display = 'none'; upsellAdded = false; return; }
    // Reset upsellAdded if the upsell product was removed from cart
    if (upsellAdded && activeUpsell) {
      var stillInCart = cart.items.some(function(item) { return item.handle === activeUpsell.upsell_handle; });
      if (!stillInCart) upsellAdded = false;
    }
    if (upsellAdded) { upsellEl.style.display = 'none'; return; }

    var cartHandles = cart.items.map(function(item) { return item.handle; });
    var matched = null;

    // Find first matching rule based on cart contents
    for (var i = 0; i < upsellRules.length; i++) {
      var rule = upsellRules[i];
      if (rule.trigger === '_default') continue;
      if (cartHandles.indexOf(rule.trigger) !== -1 && cartHandles.indexOf(rule.upsell_handle) === -1) {
        matched = rule;
        break;
      }
    }

    // Fall back to default if no specific match, and default upsell not already in cart
    if (!matched) {
      for (var j = 0; j < upsellRules.length; j++) {
        if (upsellRules[j].trigger === '_default' && cartHandles.indexOf(upsellRules[j].upsell_handle) === -1) {
          matched = upsellRules[j];
          break;
        }
      }
    }

    if (!matched) { upsellEl.style.display = 'none'; return; }

    activeUpsell = matched;
    var bannerEl = document.getElementById('upsellBanner');
    var titleEl = document.getElementById('upsellTitle');
    if (bannerEl) {
      if (matched.banner === 'float') {
        bannerEl.textContent = 'MAKE IT FLOAT!';
        bannerEl.style.background = 'linear-gradient(135deg, #0ea5e9, #06b6d4)';
        if (titleEl) titleEl.textContent = 'Water-Proof Your Gear';
      } else if (matched.banner === 'clean') {
        bannerEl.textContent = 'CRYSTAL CLEAR LENSES';
        bannerEl.style.background = 'linear-gradient(135deg, #22c55e, #16a34a)';
        if (titleEl) titleEl.textContent = 'Get Cleaner Glasses!';
      } else {
        bannerEl.textContent = 'COMPLETE YOUR KIT';
        bannerEl.style.background = '';
        if (titleEl) titleEl.textContent = 'Level Up Your Gear';
      }
    }
    document.getElementById('upsellDesc').innerHTML = matched.desc;
    document.getElementById('upsellImg').src = matched.product_img;
    document.getElementById('upsellImg').alt = matched.product_title;
    var priceHtml = '';
    if (matched.sale_price && matched.original_price) {
      priceHtml = '<span class="cart-upsell-original">' + matched.original_price + '</span>' +
        '<span class="cart-upsell-sale">' + matched.sale_price + '</span>' +
        '<span class="cart-upsell-badge">' + (matched.discount_label || 'SALE') + '</span>';
    } else {
      priceHtml = '<span class="cart-upsell-sale">' + matched.product_price + '</span>';
    }
    document.getElementById('upsellPrice').innerHTML = priceHtml;

    var pickerEl = document.getElementById('upsellVariantPicker');
    var selectEl = document.getElementById('upsellVariantSelect');
    if (matched.has_variants && matched.variants && matched.variants.length > 1) {
      selectEl.innerHTML = '';
      matched.variants.forEach(function(v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title;
        if (v.img) opt.setAttribute('data-img', v.img);
        selectEl.appendChild(opt);
      });
      selectEl.onchange = function() {
        var selectedOpt = this.options[this.selectedIndex];
        var varImg = selectedOpt.getAttribute('data-img');
        if (varImg) {
          document.getElementById('upsellImg').src = varImg;
        }
      };
      pickerEl.style.display = 'block';
    } else {
      pickerEl.style.display = 'none';
    }

    upsellEl.style.display = 'block';
  }

  window._addUpsell = function() {
    if (!activeUpsell || upsellAdded) return;
    var vid;
    if (activeUpsell.has_variants) {
      var selectEl = document.getElementById('upsellVariantSelect');
      vid = selectEl ? parseInt(selectEl.value) : (activeUpsell.variants && activeUpsell.variants[0] ? activeUpsell.variants[0].id : null);
    } else {
      vid = activeUpsell.variant_id;
    }
    if (!vid) return;
    upsellAdded = true;
    showConfetti();
    addToCart(vid, 1);
  };

  // ===== CONFETTI + SPINNING ANCHOR =====
  function showConfetti() {
    var container = document.createElement('div');
    container.className = 'confetti-container';
    var colors = ['#0ea5e9', '#22d3ee', '#ff6b35', '#22c55e', '#f59e0b', '#a855f7', '#ec4899', '#fff'];
    for (var i = 0; i < 40; i++) {
      var piece = document.createElement('div');
      piece.className = 'confetti-piece';
      piece.style.left = Math.random() * 100 + '%';
      piece.style.background = colors[Math.floor(Math.random() * colors.length)];
      piece.style.animationDelay = Math.random() * 1.5 + 's';
      piece.style.width = (Math.random() * 8 + 6) + 'px';
      piece.style.height = (Math.random() * 8 + 6) + 'px';
      container.appendChild(piece);
    }
    document.body.appendChild(container);
    var anchor = document.createElement('div');
    anchor.className = 'spinning-anchor';
    anchor.innerHTML = '<svg width="120" height="120" viewBox="0 0 28 28" fill="none"><circle cx="14" cy="14" r="12" stroke="#0ea5e9" stroke-width="2"/><circle cx="14" cy="7" r="2" stroke="#0ea5e9" stroke-width="1.5"/><line x1="14" y1="9" x2="14" y2="23" stroke="#0ea5e9" stroke-width="2" stroke-linecap="round"/><path d="M7 17c0 4 3.5 6 7 6s7-2 7-6" stroke="#0ea5e9" stroke-width="2" stroke-linecap="round" fill="none"/><line x1="10" y1="14" x2="18" y2="14" stroke="#0ea5e9" stroke-width="2" stroke-linecap="round"/></svg>';
    document.body.appendChild(anchor);
    setTimeout(function() { container.remove(); anchor.remove(); }, 4500);
  }

  // ===== GLOBAL CART FUNCTIONS =====
  window._cartQty = function(key, qty) {
    changeCartItem(key, qty);
  };

  // ===== QUICK ADD BUTTONS (Shopify variant IDs) =====
  document.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = parseInt(this.getAttribute('data-add-to-cart'));
      if (variantId) addToCart(variantId, 1);
    });
  });

  // ===== SWATCH CLICK - SWAP MAIN IMAGE =====
  document.querySelectorAll('.product-swatches .swatch').forEach(function(swatch) {
    swatch.addEventListener('click', function(e) {
      e.stopPropagation();
      var variantImg = this.getAttribute('data-variant-img');
      if (!variantImg) return;
      var swatchContainer = this.closest('.product-swatches');
      swatchContainer.querySelectorAll('.swatch').forEach(function(s) { s.classList.remove('active'); });
      this.classList.add('active');
      var card = this.closest('.product-card');
      var img = card.querySelector('.product-img-inner img');
      if (img) {
        img.style.opacity = '0';
        img.style.transition = 'opacity 0.25s ease';
        setTimeout(function() {
          img.src = variantImg;
          img.style.opacity = '1';
        }, 150);
      }
    });
  });

  // ===== SCROLL ANIMATIONS =====
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  document.querySelectorAll('.product-card, .feature-card').forEach(function(el, i) {
    el.style.transitionDelay = (i % 4) * 0.1 + 's';
    el.style.transition = 'opacity 0.6s ease ' + (i % 4) * 0.1 + 's, transform 0.6s ease ' + (i % 4) * 0.1 + 's';
    observer.observe(el);
  });

  document.querySelectorAll('.feature-card').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(40px)';
  });
  var featureObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.feature-card').forEach(function(el) {
    featureObserver.observe(el);
  });

  // ===== BACK TO TOP =====
  if (backToTop) {
    backToTop.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ===== NEWSLETTER =====
  var nlFormParent = newsletterForm ? newsletterForm.closest('form') : null;
  if (nlFormParent) {
    nlFormParent.addEventListener('submit', function(e) {
      var input = this.querySelector('input[type="email"]');
      var btn = this.querySelector('button');
      var email = input.value.trim();
      if (!email) { e.preventDefault(); return; }
      // Let Shopify handle the form submission natively
      btn.textContent = 'Subscribing...';
      btn.disabled = true;
    });
  }

  // ===== SMOOTH SCROLL FOR NAV LINKS =====
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ===== KEYBOARD: ESC TO CLOSE =====
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCart();
      closeMobile();
      // Close modal
      var modalOverlay = document.querySelector('.modal-overlay.open');
      if (modalOverlay) modalOverlay.classList.remove('open');
    }
  });

  // ===== BEFORE/AFTER COMPARISON SLIDERS =====
  (function() {
    var sliders = document.querySelectorAll('.js-comparison-slider');
    var activeSlider = null;

    sliders.forEach(function(slider) {
      var beforeImg = slider.querySelector('.comparison-img-before');
      var divider = slider.querySelector('.comparison-divider');
      var handle = slider.querySelector('.comparison-handle');

      function setPosition(x) {
        var rect = slider.getBoundingClientRect();
        var pos = Math.max(0, Math.min(x - rect.left, rect.width));
        var pct = (pos / rect.width) * 100;
        beforeImg.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        divider.style.left = pct + '%';
        handle.style.left = pct + '%';
      }

      slider.addEventListener('mousedown', function(e) {
        e.preventDefault();
        activeSlider = { setPosition: setPosition };
        setPosition(e.clientX);
      });

      slider.addEventListener('touchstart', function(e) {
        activeSlider = { setPosition: setPosition };
        setPosition(e.touches[0].clientX);
      }, { passive: true });
    });

    document.addEventListener('mousemove', function(e) {
      if (!activeSlider) return;
      e.preventDefault();
      activeSlider.setPosition(e.clientX);
    });
    document.addEventListener('mouseup', function() { activeSlider = null; });
    document.addEventListener('touchmove', function(e) {
      if (!activeSlider) return;
      activeSlider.setPosition(e.touches[0].clientX);
    }, { passive: true });
    document.addEventListener('touchend', function() { activeSlider = null; });
  })();

  // ===== VIDEO SHUFFLE =====
  (function() {
    var grid = document.querySelector('.yt-vertical-grid');
    if (!grid) return;
    var cards = Array.from(grid.querySelectorAll('.yt-vertical-card'));
    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = cards[i];
      cards[i] = cards[j];
      cards[j] = temp;
    }
    cards.forEach(function(card) { grid.appendChild(card); });
  })();

  // ===== PRODUCT FILTER (homepage) =====
  window.filterProducts = function(category, btn) {
    document.querySelectorAll('.filter-btn').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
    document.querySelectorAll('.product-card').forEach(function(card) {
      if (category === 'all' || (card.dataset.category && card.dataset.category.indexOf(category) !== -1)) {
        card.style.display = '';
        card.style.animation = 'fadeInUp 0.4s ease forwards';
      } else {
        card.style.display = 'none';
      }
    });
  };

  // ===== CHECKOUT BUTTON =====
  document.querySelectorAll('.cart-checkout-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      window.location.href = '/cart';
    });
  });

  // ===== TOUCH SWIPE ON MAIN PRODUCT IMAGE =====
  (function() {
    var mainImg = document.querySelector('.pdp-main-img, .main-image-wrap, .product-page-main-img');
    if (!mainImg) return;
    var startX = 0, threshold = 50;
    mainImg.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    mainImg.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > threshold) {
        if (typeof navImage === 'function') {
          if (dx < 0) { navImage(1); } else { navImage(-1); }
        }
      }
    }, { passive: true });
  })();

  // ===== INIT: FETCH CART ON LOAD =====
  fetchCart();

})();

// ===== THEME TOGGLE =====
function toggleTheme() {
  document.body.classList.toggle('light-mode');
  var isLight = document.body.classList.contains('light-mode');
  var icon = isLight ? '&#9728;&#65039;' : '&#127769;';
  var btn = document.getElementById('themeToggle');
  var mBtn = document.getElementById('mobileThemeToggle');
  if (btn) btn.innerHTML = icon;
  if (mBtn) mBtn.innerHTML = icon;
  localStorage.setItem('anchorTheme', isLight ? 'light' : 'dark');
}
(function() {
  var theme = localStorage.getItem('anchorTheme');
  if (theme === 'dark') {
    // User explicitly chose dark — keep dark (default body state)
  } else {
    // First visit (null) or explicit 'light' — apply light mode
    document.body.classList.add('light-mode');
    var icon = '&#9728;&#65039;';
    var btn = document.getElementById('themeToggle');
    var mBtn = document.getElementById('mobileThemeToggle');
    if (btn) btn.innerHTML = icon;
    if (mBtn) mBtn.innerHTML = icon;
  }
})();

/* ============================================================
   SimGym fix 2026-05-22 — Global toast notification helper.
   Used to confirm "Bundle Added", discount applied, etc., so
   shoppers always see explicit feedback after a cart action.
   ============================================================ */
(function () {
  function ensureContainer() {
    var c = document.getElementById('anchor-toast-stack');
    if (c) return c;
    c = document.createElement('div');
    c.id = 'anchor-toast-stack';
    c.setAttribute('aria-live', 'polite');
    c.style.cssText = 'position:fixed;top:80px;right:16px;z-index:9999;display:flex;flex-direction:column;gap:10px;pointer-events:none;max-width:380px;';
    document.body.appendChild(c);
    return c;
  }
  function makeToast(opts) {
    opts = opts || {};
    var title = opts.title || '';
    var body = opts.body || '';
    var duration = typeof opts.duration === 'number' ? opts.duration : 4000;
    var t = document.createElement('div');
    t.style.cssText = [
      'pointer-events:auto',
      'background:linear-gradient(135deg, #22c55e, #16a34a)',
      'color:#fff',
      'padding:14px 18px',
      'border-radius:12px',
      'box-shadow:0 10px 30px rgba(0,0,0,0.3)',
      'font-family:inherit',
      'min-width:280px',
      'opacity:0',
      'transform:translateX(20px)',
      'transition:opacity 0.25s ease, transform 0.25s ease',
      'cursor:pointer'
    ].join(';');
    t.innerHTML =
      '<div style="font-weight:700;font-size:0.95rem;margin-bottom:' + (body ? '4px' : '0') + ';">' +
        (title.replace(/[<>]/g, '')) +
      '</div>' +
      (body ? '<div style="font-size:0.82rem;opacity:0.95;line-height:1.4;">' + body.replace(/[<>]/g, '') + '</div>' : '');
    var stack = ensureContainer();
    stack.appendChild(t);
    requestAnimationFrame(function () {
      t.style.opacity = '1';
      t.style.transform = 'translateX(0)';
    });
    var removed = false;
    function remove() {
      if (removed) return;
      removed = true;
      t.style.opacity = '0';
      t.style.transform = 'translateX(20px)';
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 280);
    }
    t.addEventListener('click', remove);
    setTimeout(remove, duration);
    return t;
  }
  window._anchorToast = makeToast;
})();
